import { surveyLocalization } from "../surveyStrings";

export var czechSurveyStrings = {
  pagePrevText: "Předchozí",
  pageNextText: "Další",
  completeText: "Hotovo",
  previewText: "Náhled",
  editText: "Upravit",
  startSurveyText: "Start",
  otherItemText: "Jiná odpověď (napište)",
  noneItemText: "Žádný",
  selectAllItemText: "Vybrat vše",
  progressText: "Strana {0} z {1}",
  panelDynamicProgressText: "Záznam {0} z {1}",
  questionsProgressText: "Zodpovězené otázky: {0} / {1}",
  emptySurvey: "Průzkumu neobsahuje žádné otázky.",
  completingSurvey: "Děkujeme za vyplnění průzkumu!",
  completingSurveyBefore:
    "Naše záznamy ukazují, že jste tento průzkum již dokončili.",
  loadingSurvey: "Probíhá načítání průzkumu...",
  optionsCaption: "Vyber...",
  value: "hodnota",
  requiredError: "Odpovězte prosím na otázku.",
  requiredErrorInPanel: "Please answer at least one question.",
  requiredInAllRowsError: "Odpovězte prosím na všechny otázky.",
  numericError: "V tomto poli lze zadat pouze čísla.",
  textMinLength: "Zadejte prosím alespoň {0} znaků.",
  textMaxLength: "Zadejte prosím méně než {0} znaků.",
  textMinMaxLength: "Zadejte prosím více než {0} a méně než {1} znaků.",
  minRowCountError: "Vyplňte prosím alespoň {0} řádků.",
  minSelectError: "Vyberte prosím alespoň {0} varianty.",
  maxSelectError: "Nevybírejte prosím více než {0} variant.",
  numericMinMax:
    "Odpověď '{0}' by mělo být větší nebo rovno {1} a menší nebo rovno {2}",
  numericMin: "Odpověď '{0}' by mělo být větší nebo rovno {1}",
  numericMax: "Odpověď '{0}' by mělo být menší nebo rovno {1}",
  invalidEmail: "Zadejte prosím platnou e-mailovou adresu.",
  invalidExpression: "Výraz: {0} by měl vrátit hodnotu „true“.",
  urlRequestError: "Požadavek vrátil chybu '{0}'. {1}",
  urlGetChoicesError: "Požadavek nevrátil data nebo cesta je neplatná",
  exceedMaxSize: "Velikost souboru by neměla být větší než {0}.",
  otherRequiredError: "Zadejte prosím jinou hodnotu.",
  uploadingFile: "Váš soubor se nahrává. Zkuste to prosím za několik sekund.",
  loadingFile: "Načítání...",
  chooseFile: "Vyberte soubory ...",
  noFileChosen: "Není zvolený žádný soubor",
  confirmDelete: "Chcete smazat záznam?",
  keyDuplicationError: "Tato hodnota by měla být jedinečná.",
  addColumn: "Přidat sloupec",
  addRow: "Přidat řádek",
  removeRow: "Odstranit",
  addPanel: "Přidat nový",
  removePanel: "Odstranit",
  choices_Item: "položka",
  matrix_column: "Sloupec",
  matrix_row: "Řádek",
  savingData: "Výsledky se ukládají na server ...",
  savingDataError: "Došlo k chybě a výsledky jsme nemohli uložit.",
  savingDataSuccess: "Výsledky byly úspěšně uloženy!",
  saveAgainButton: "Zkus to znovu",
  timerMin: "min",
  timerSec: "sek",
  timerSpentAll: "Na této stránce jste utratili celkem {0} a celkem {1}.",
  timerSpentPage: "Na této stránce jste utratili {0}.",
  timerSpentSurvey: "Celkem jste utratili {0}.",
  timerLimitAll:
    "Na této stránce jste utratili {0} z {1} a celkem {2} z {3}.",
  timerLimitPage: "Na této stránce jste strávili {0} z {1}.",
  timerLimitSurvey: "Celkově jste utratili {0} z {1}.",
  cleanCaption: "Čistý",
  clearCaption: "Průhledná",
  chooseFileCaption: "Vyberte soubor",
  removeFileCaption: "Odeberte tento soubor",
  booleanCheckedLabel: "Ano",
  booleanUncheckedLabel: "Ne",
  confirmRemoveFile: "Opravdu chcete odebrat tento soubor: {0}?",
  confirmRemoveAllFiles: "Opravdu chcete odstranit všechny soubory?",
  questionTitlePatternText: "Název otázky",
};

surveyLocalization.locales["cs"] = czechSurveyStrings;
surveyLocalization.localeNames["cs"] = "čeština";
